import React from 'react';
import PaymentDetailsForm from "../../Components/Pages/Authentication/paymentDetails"
import AppProvider from "./../../Components/bootstrap"
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';

// import CircularProgress from '@material-ui/core/CircularProgress';
import { useRedirect ,useAuthenticated} from 'react-admin';
// import { useDataProvider, , useRedirect } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
// import * as yup from "yup"
// import { setIn } from "final-form";
import { Form } from 'react-final-form';
import Parse from "./../../Utils/index"

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },

    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    // TextField: {
    //     marginTop: "8%",
    //     backgroundColor: "#ffffff"
    // },
    coverBackgroundContainer: {
        backgroundColor: "#F7F8F9",
        height: "100vh",
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: "4%",
        paddingRight: "4%",
        paddingTop: "40px",
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
        width: '100%'
    },
    buttonSuccess: {
        backgroundColor: 'primary',
        width: '100%',
        '&:hover': {
            backgroundColor: 'primary',
        },
    },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

export default function PaymentDetails() {
    const redirect = useRedirect()
    useAuthenticated()
    // const notify = useNotify
    const onSubmitDetails = async ({ accountName, accountNumber, IFSC, bankName }) => {
        try {
            const user = Parse.User.current()
            const PaymentDetail = Parse.Object.extend('PaymentDetail')
            const paymentDetail = new PaymentDetail()
            paymentDetail.set("accountName", accountName)
            paymentDetail.set("accountNumber", accountNumber)
            paymentDetail.set("IFSC", IFSC)
            paymentDetail.set("bankName", bankName)
            paymentDetail.set("user", user)

            await paymentDetail.save()
            user.set('stage', "SET_AVAILABILITY")
            await user.save()
            redirect("/selecttimeslot")
        } catch (e) {
            
        }
    }
    const classes = useStyles();
    // const buttonClassname = clsx({
    //     // [classes.buttonSuccess]: success,
    // })
    return (
        <AppProvider>
            <div className={classes.coverBackgroundContainer}>
                {/* <AppBar /> */}
                <Container component="main" maxWidth="xs" style={{ background: "#ffffff", }}>
                    <Typography component="h6" variant="h6" style={{ paddingTop: "7%", marginLeft: "20%" }}>
                        Add Payment Details
             </Typography>
                    <Form
                        onSubmit={onSubmitDetails}
                        render={PaymentDetailsForm}
                    />
                </Container>
            </div>
        </AppProvider>
    );
}
